import { v4 as uuidv4 } from 'uuid';
// Types
import QuestionTypes from 'types/QuestionTypes';
import QuizTypes from 'types/QuizTypes';
// Models
import IAnswer from 'models/Answer';
import IBucket from 'models/Bucket';
import IOption from 'models/Option';
// Utilities
import { textFromCamelToNormalCase } from 'utilities/utilities';
import QuestionFormats from 'types/QuestionFormats';

export default class QuestionService {
  public static initialQuestion() {
    return {
      ref: uuidv4(),
      title: '',
      // description: '',
      type: QuestionTypes.SingleChoice,
      // image: '',
      // video: '',
      answers: []
    };
  }

  public static initialAnswer(buckets:IBucket[] | undefined) {
    const answer:IAnswer = { ref: uuidv4(), title: '', correct: false };
    if ( buckets && buckets.length ) answer['bucketScores'] = buckets.map((bucket:IBucket) => ({
      ref: bucket.ref,
      score: 0
    }));
    return answer;
  }

  public static questionTypeOptions(quizType?:QuizTypes):IOption[] {
    const options = [
      { value: QuestionTypes.SingleChoice, label: textFromCamelToNormalCase(QuestionTypes.SingleChoice) },
    ]

    if (quizType && ![QuizTypes.Scoring, QuizTypes.BeatTheExpert, QuizTypes.Streak].includes(quizType)) {
      options.push({ value: QuestionTypes.MultiChoice, label: textFromCamelToNormalCase(QuestionTypes.MultiChoice) });
    }

    if (quizType !== QuizTypes.Personality) {
      options.push({ value: QuestionTypes.ShortText, label: textFromCamelToNormalCase(QuestionTypes.ShortText) });
    }

    if (quizType === QuizTypes.Scoring) {
      options.push({ value: QuestionTypes.Ranking, label: textFromCamelToNormalCase(QuestionTypes.Ranking) });
    }

    return options;
  }

  public static questionFormatOptions() {
    return (Object.keys(QuestionFormats) as Array<keyof typeof QuestionFormats>)
      .map((key) => ({
        value: QuestionFormats[key],
        label: textFromCamelToNormalCase(key)
      }));
  }
}
